












































import { computed, defineComponent }                 from '@vue/composition-api';
import cTable                                        from '@/components/table/table.component.vue';
import cRowActions                                   from '@/components/row-actions/row-actions.component.vue';
import { useGlobals }                                from '@/hooks/use-globals';
import { Computed, ObjectWithStringKeys }            from '@/types';
import { ReportsList }                               from '@/views/dynamic-tables/dynamic-tables.types';
import { State }                                     from '@/views/dynamic-tables/store/dynamic-tables.state.store';
import { nameModeEdit as vDynamicTablesBuilderEdit } from '@/views/dynamic-tables-builder/dynamic-tables-builder.route';
import { getViewStorePath }                          from '@/store/store.helpers';
import { name as vDynamicTablesPreview }             from '@/views/dynamic-tables-preview/dynamic-tables-preview.route';
import { MessageBox }                                from '@/components/message-box/message-box';
import { MessageBoxInputData }                       from 'element-ui/types/message-box';
import useGlobalTranslation                          from '@/hooks/use-global-translations';
import { quietlyHandleError }                        from '@/helpers/helpers';
import { name }                                      from '../dynamic-tables.route';

export default defineComponent({
  name: 'cDynamicTablesTableList',
  components: {
    cTable,
    cRowActions,
  },
  setup() {
    const { store, router, i18n } = useGlobals();
    const columns: string[] = [ 'name', 'creationDate', 'actions' ];
    const state: Computed<State> = computed(() => store.state.views.vDynamicTables);
    const dataLoaded: Computed<boolean> = computed(() => state.value.dataLoaded);
    const tableData: Computed<ReportsList[]> = computed(() => state.value.dynamicTables);
    const actionRequiredTranslation: string = useGlobalTranslation('messageBox.actionRequired')
      .toString();
    const fieldIsRequiredTranslation: string = useGlobalTranslation('errors.fieldIsRequired')
      .toString();
    const provideName: string = i18n.t('vDynamicTables.messageBox.provideCopyName')
      .toString();

    const deleteRow = (row: ReportsList): void => {
      store.dispatch(`${getViewStorePath(name)}/deleteDynamicTable`, row.uuid);
    };

    const exportToExcel = (row: ReportsList): void => {
      store.dispatch(`${getViewStorePath(name)}/exportToExcel`, row);
    };

    const onEditAction = async (uuid: string): Promise<void> => {
      await router.push({
        name: vDynamicTablesBuilderEdit,
        params: { dynamicTableUuid: uuid },
      });
    };

    const onCopyAction = async (uuid: string) => {
      try {
        const { value }: { value: string } = await MessageBox.prompt(provideName, actionRequiredTranslation, {
          inputValidator: (value: string): boolean => !!value?.trim().length,
          inputErrorMessage: fieldIsRequiredTranslation,
        }) as MessageBoxInputData;
        await store.dispatch('views/vDynamicTables/copyDynamicTable', { tableName: value, tableUuid: uuid });
        await store.dispatch('views/vDynamicTables/getDynamicTables');
      } catch (e) {
        quietlyHandleError(e, 'MessageBox error');
      }
    };

    const getRouterLinkToParam = (id: string): { name: string; params: ObjectWithStringKeys<string> } => ({
      name: vDynamicTablesPreview,
      params: {
        dynamicTableUuid: id,
      },
    });

    return {
      columns,
      tableData,
      deleteRow,
      exportToExcel,
      dataLoaded,
      onEditAction,
      onCopyAction,
      getRouterLinkToParam,
    };
  },
});
